
// src/config/stamps.js

// function require() {}

// スタンプの一覧
const stamps = [
    {
      category: 'animal',
      code: 'animal-dog-got-it',
      label: '承知しました',
      svg: 'animal-dog-got-it.svg',
      png: 'animal-dog-got-it.png',
      source: require('../assets/stamps/animal-dog-got-it.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-got-it2',
      label: '了解です',
      svg: 'animal-dog-got-it2.svg',
      png: 'animal-dog-got-it2.png',
      source: require('../assets/stamps/animal-dog-got-it2.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-got-it',
      label: '承知いたしました',
      svg: 'animal-cat-got-it.svg',
      png: 'animal-cat-got-it.png',
      source: require('../assets/stamps/animal-cat-got-it.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-got-it2',
      label: '了解です',
      svg: 'animal-cat-got-it2.svg',
      png: 'animal-cat-got-it2.png',
      source: require('../assets/stamps/animal-cat-got-it2.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-got-it',
      label: '承知いたしました',
      svg: 'animal-rabbit-got-it.svg',
      png: 'animal-rabbit-got-it.png',
      source: require('../assets/stamps/animal-rabbit-got-it.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-got-it2',
      label: '了解です',
      svg: 'animal-rabbit-got-it2.svg',
      png: 'animal-rabbit-got-it2.png',
      source: require('../assets/stamps/animal-rabbit-got-it2.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-got-it',
      label: '承知いたしました',
      svg: 'animal-penguin-got-it.svg',
      png: 'animal-penguin-got-it.png',
      source: require('../assets/stamps/animal-penguin-got-it.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-got-it2',
      label: '了解です',
      svg: 'animal-penguin-got-it2.svg',
      png: 'animal-penguin-got-it2.png',
      source: require('../assets/stamps/animal-penguin-got-it2.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-wakarimasu',
      label: 'わかります',
      svg: 'animal-kawauso-wakarimasu.svg',
      png: 'animal-kawauso-wakarimasu.png',
      source: require('../assets/stamps/animal-kawauso-wakarimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-yarimasita',
      label: 'やりました',
      svg: 'animal-kawauso-yarimasita.svg',
      png: 'animal-kawauso-yarimasita.png',
      source: require('../assets/stamps/animal-kawauso-yarimasita.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-hai',
      label: 'はい',
      svg: 'animal-kawauso-hai.svg',
      png: 'animal-kawauso-hai.png',
      source: require('../assets/stamps/animal-kawauso-hai.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-iyaiya',
      label: 'いやいや',
      svg: 'animal-kawauso-iyaiya.svg',
      png: 'animal-kawauso-iyaiya.png',
      source: require('../assets/stamps/animal-kawauso-iyaiya.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-jidannda',
      label: 'じだんだ',
      svg: 'animal-kawauso-jidannda.svg',
      png: 'animal-kawauso-jidannda.png',
      source: require('../assets/stamps/animal-kawauso-jidannda.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-thank-you',
      label: 'ありがとうございます',
      svg: 'animal-dog-thank-you.svg',
      png: 'animal-dog-thank-you.png',
      source: require('../assets/stamps/animal-dog-thank-you.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-thank-you',
      label: 'ありがとうございます',
      svg: 'animal-cat-thank-you.svg',
      png: 'animal-cat-thank-you.png',
      source: require('../assets/stamps/animal-cat-thank-you.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-thank-you',
      label: 'ありがとうございます',
      svg: 'animal-rabbit-thank-you.svg',
      png: 'animal-rabbit-thank-you.png',
      source: require('../assets/stamps/animal-rabbit-thank-you.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-thank-you',
      label: 'ありがとうございます',
      svg: 'animal-penguin-thank-you.svg',
      png: 'animal-penguin-thank-you.png',
      source: require('../assets/stamps/animal-penguin-thank-you.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-bow',
      label: 'お辞儀',
      svg: 'animal-cat-bow.svg',
      png: 'animal-cat-bow.png',
      source: require('../assets/stamps/animal-cat-bow.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-bow',
      label: 'お辞儀',
      svg: 'animal-rabbit-bow.svg',
      png: 'animal-rabbit-bow.png',
      source: require('../assets/stamps/animal-rabbit-bow.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-ojigi',
      label: 'お辞儀',
      svg: 'animal-kawauso-ojigi.svg',
      png: 'animal-kawauso-ojigi.png',
      source: require('../assets/stamps/animal-kawauso-ojigi.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-utubuse',
      label: 'うつ伏せ',
      svg: 'animal-kawauso-utubuse.svg',
      png: 'animal-kawauso-utubuse.png',
      source: require('../assets/stamps/animal-kawauso-utubuse.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-helpful',
      label: '助かります',
      svg: 'animal-dog-helpful.svg',
      png: 'animal-dog-helpful.png',
      source: require('../assets/stamps/animal-dog-helpful.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-helpful',
      label: '助かります',
      svg: 'animal-penguin-helpful.svg',
      png: 'animal-penguin-helpful.png',
      source: require('../assets/stamps/animal-penguin-helpful.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-tasukarimasu',
      label: '助かります',
      svg: 'animal-kawauso-tasukarimasu.svg',
      png: 'animal-kawauso-tasukarimasu.png',
      source: require('../assets/stamps/animal-kawauso-tasukarimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-omedetou',
      label: 'おめでとう',
      svg: 'animal-kawauso-omedetou.svg',
      png: 'animal-kawauso-omedetou.png',
      source: require('../assets/stamps/animal-kawauso-omedetou.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-omedetou-gozaimasu',
      label: 'おめでとうま',
      svg: 'animal-kawauso-omedetou-gozaimasu.svg',
      png: 'animal-kawauso-omedetou-gozaimasu.png',
      source: require('../assets/stamps/animal-kawauso-omedetou-gozaimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-good-work',
      label: 'お疲れ様です',
      svg: 'animal-dog-good-work.svg',
      png: 'animal-dog-good-work.png',
      source: require('../assets/stamps/animal-dog-good-work.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-good-work',
      label: 'お疲れ様です',
      svg: 'animal-rabbit-good-work.svg',
      png: 'animal-rabbit-good-work.png',
      source: require('../assets/stamps/animal-rabbit-good-work.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-sincerely',
      label: 'よろしくお願いします',
      svg: 'animal-dog-sincerely.svg',
      png: 'animal-dog-sincerely.png',
      source: require('../assets/stamps/animal-dog-sincerely.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-sincerely',
      label: 'よろしくお願いします',
      svg: 'animal-cat-sincerely.svg',
      png: 'animal-cat-sincerely.png',
      source: require('../assets/stamps/animal-cat-sincerely.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-you-are-welcome',
      label: 'どういたしまして',
      svg: 'animal-cat-you-are-welcome.svg',
      png: 'animal-cat-you-are-welcome.png',
      source: require('../assets/stamps/animal-cat-you-are-welcome.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-you-are-welcome',
      label: 'どういたしまして',
      svg: 'animal-rabbit-you-are-welcome.svg',
      png: 'animal-rabbit-you-are-welcome.png',
      source: require('../assets/stamps/animal-rabbit-you-are-welcome.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-happy',
      label: 'うれしい',
      svg: 'animal-kawauso-happy.svg',
      png: 'animal-kawauso-happy.png',
      source: require('../assets/stamps/animal-kawauso-happy.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-sorry',
      label: '申し訳ありません',
      svg: 'animal-cat-sorry.svg',
      png: 'animal-cat-sorry.png',
      source: require('../assets/stamps/animal-cat-sorry.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-sorry',
      label: '申し訳ありません',
      svg: 'animal-penguin-sorry.svg',
      png: 'animal-penguin-sorry.png',
      source: require('../assets/stamps/animal-penguin-sorry.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-oisoginotokorosumimasenn',
      label: 'お忙しいところ',
      svg: 'animal-kawauso-oisoginotokorosumimasenn.svg',
      png: 'animal-kawauso-oisoginotokorosumimasenn.png',
      source: require('../assets/stamps/animal-kawauso-oisoginotokorosumimasenn.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-dogeza',
      label: '土下座',
      svg: 'animal-cat-dogeza.svg',
      png: 'animal-cat-dogeza.png',
      source: require('../assets/stamps/animal-cat-dogeza.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-dogeza',
      label: '土下座',
      svg: 'animal-rabbit-dogeza.svg',
      png: 'animal-rabbit-dogeza.png',
      source: require('../assets/stamps/animal-rabbit-dogeza.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-shocking',
      label: 'ショック',
      svg: 'animal-dog-shocking.svg',
      png: 'animal-dog-shocking.png',
      source: require('../assets/stamps/animal-dog-shocking.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-shocking',
      label: 'ショック',
      svg: 'animal-penguin-shocking.svg',
      png: 'animal-penguin-shocking.png',
      source: require('../assets/stamps/animal-penguin-shocking.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-shock',
      label: 'ショック',
      svg: 'animal-kawauso-shock.svg',
      png: 'animal-kawauso-shock.png',
      source: require('../assets/stamps/animal-kawauso-shock.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-hello',
      label: 'こんにちは',
      svg: 'animal-dog-hello.svg',
      png: 'animal-dog-hello.png',
      source: require('../assets/stamps/animal-dog-hello.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-hello',
      label: 'こんにちは',
      svg: 'animal-penguin-hello.svg',
      png: 'animal-penguin-hello.png',
      source: require('../assets/stamps/animal-penguin-hello.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-good-morning',
      label: 'おはようございます',
      svg: 'animal-rabbit-good-morning.svg',
      png: 'animal-rabbit-good-morning.png',
      source: require('../assets/stamps/animal-rabbit-good-morning.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-good-morning',
      label: 'おはようございます',
      svg: 'animal-penguin-good-morning.svg',
      png: 'animal-penguin-good-morning.png',
      source: require('../assets/stamps/animal-penguin-good-morning.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-I-agree',
      label: '同感です',
      svg: 'animal-cat-I-agree.svg',
      png: 'animal-cat-I-agree.png',
      source: require('../assets/stamps/animal-cat-I-agree.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-I-agree',
      label: '同感です',
      svg: 'animal-rabbit-I-agree.svg',
      png: 'animal-rabbit-I-agree.png',
      source: require('../assets/stamps/animal-rabbit-I-agree.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-no-problem',
      label: 'とんでもございません',
      svg: 'animal-dog-no-problem.svg',
      png: 'animal-dog-no-problem.png',
      source: require('../assets/stamps/animal-dog-no-problem.png')
    },
    {
      category: 'animal',
      code: 'animal-cat-no-problem',
      label: 'ありがとうございます',
      svg: 'animal-cat-no-problem.svg',
      png: 'animal-cat-no-problem.png',
      source: require('../assets/stamps/animal-cat-no-problem.png')
    },
    {
      category: 'animal',
      code: 'animal-bear-odaijini',
      label: 'お大事に',
      svg: 'animal-bear-odaijini.svg',
      png: 'animal-bear-odaijini.png',
      source: require('../assets/stamps/animal-bear-odaijini.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-odaijini',
      label: 'お大事に',
      svg: 'animal-kawauso-odaijini.svg',
      png: 'animal-kawauso-odaijini.png',
      source: require('../assets/stamps/animal-kawauso-odaijini.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-kakuninn-memo',
      label: '確認します',
      svg: 'animal-kawauso-kakuninn-memo.svg',
      png: 'animal-kawauso-kakuninn-memo.png',
      source: require('../assets/stamps/animal-kawauso-kakuninn-memo.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-kakuninnsimasu',
      label: '確認します',
      svg: 'animal-kawauso-kakuninnsimasu.svg',
      png: 'animal-kawauso-kakuninnsimasu.png',
      source: require('../assets/stamps/animal-kawauso-kakuninnsimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-sirabetemimasu',
      label: '調べてみます',
      svg: 'animal-kawauso-sirabetemimasu.svg',
      png: 'animal-kawauso-sirabetemimasu.png',
      source: require('../assets/stamps/animal-kawauso-sirabetemimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-bear-soredesu',
      label: 'それです',
      svg: 'animal-bear-soredesu.svg',
      png: 'animal-bear-soredesu.png',
      source: require('../assets/stamps/animal-bear-soredesu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-niceidea',
      label: 'ナイスアイデア',
      svg: 'animal-kawauso-niceidea.svg',
      png: 'animal-kawauso-niceidea.png',
      source: require('../assets/stamps/animal-kawauso-niceidea.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-yubisasi',
      label: '指差し',
      svg: 'animal-kawauso-yubisasi.svg',
      png: 'animal-kawauso-yubisasi.png',
      source: require('../assets/stamps/animal-kawauso-yubisasi.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-cheers',
      label: 'がんばってください',
      svg: 'animal-dog-cheers.svg',
      png: 'animal-dog-cheers.png',
      source: require('../assets/stamps/animal-dog-cheers.png')
    },
    {
      category: 'animal',
      code: 'animal-rabbit-cheers',
      label: 'がんばってください',
      svg: 'animal-rabbit-cheers.svg',
      png: 'animal-rabbit-cheers.png',
      source: require('../assets/stamps/animal-rabbit-cheers.png')
    },
    {
      category: 'animal',
      code: 'animal-dog-fist-pump',
      label: 'がんばってください',
      svg: 'animal-dog-fist-pump.svg',
      png: 'animal-dog-fist-pump.png',
      source: require('../assets/stamps/animal-dog-fist-pump.png')
    },
    {
      category: 'animal',
      code: 'animal-penguin-fist-pump',
      label: 'がんばってください',
      svg: 'animal-penguin-fist-pump.svg',
      png: 'animal-penguin-fist-pump.png',
      source: require('../assets/stamps/animal-penguin-fist-pump.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-fist-pump',
      label: 'がんばってください',
      svg: 'animal-kawauso-fist-pump.svg',
      png: 'animal-kawauso-fist-pump.png',
      source: require('../assets/stamps/animal-kawauso-fist-pump.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-hourglass',
      label: 'お待ちください',
      svg: 'animal-kawauso-hourglass.svg',
      png: 'animal-kawauso-hourglass.png',
      source: require('../assets/stamps/animal-kawauso-hourglass.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-makasete',
      label: 'まかせて',
      svg: 'animal-kawauso-makasete.svg',
      png: 'animal-kawauso-makasete.png',
      source: require('../assets/stamps/animal-kawauso-makasete.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-o',
      label: 'まあ',
      svg: 'animal-kawauso-o.svg',
      png: 'animal-kawauso-o.png',
      source: require('../assets/stamps/animal-kawauso-o.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-hus',
      label: 'えっ',
      svg: 'animal-kawauso-hus.svg',
      png: 'animal-kawauso-hus.png',
      source: require('../assets/stamps/animal-kawauso-hus.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-koreha-yabai',
      label: 'これはヤバい',
      svg: 'animal-kawauso-koreha-yabai.svg',
      png: 'animal-kawauso-koreha-yabai.png',
      source: require('../assets/stamps/animal-kawauso-koreha-yabai.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-sounano',
      label: 'そうなの',
      svg: 'animal-kawauso-sounano.svg',
      png: 'animal-kawauso-sounano.png',
      source: require('../assets/stamps/animal-kawauso-sounano.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-wow',
      label: 'わあ',
      svg: 'animal-kawauso-wow.svg',
      png: 'animal-kawauso-wow.png',
      source: require('../assets/stamps/animal-kawauso-wow.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-isogimasu',
      label: '急ぎます',
      svg: 'animal-kawauso-isogimasu.svg',
      png: 'animal-kawauso-isogimasu.png',
      source: require('../assets/stamps/animal-kawauso-isogimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-doya',
      label: 'どやっ',
      svg: 'animal-kawauso-doya.svg',
      png: 'animal-kawauso-doya.png',
      source: require('../assets/stamps/animal-kawauso-doya.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-doya-kiriri',
      label: 'どやっ',
      svg: 'animal-kawauso-doya-kiriri.svg',
      png: 'animal-kawauso-doya-kiriri.png',
      source: require('../assets/stamps/animal-kawauso-doya-kiriri.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-ganbarimasu',
      label: 'がんばります',
      svg: 'animal-kawauso-ganbarimasu.svg',
      png: 'animal-kawauso-ganbarimasu.png',
      source: require('../assets/stamps/animal-kawauso-ganbarimasu.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-gurasann',
      label: 'サングラス',
      svg: 'animal-kawauso-gurasann.svg',
      png: 'animal-kawauso-gurasann.png',
      source: require('../assets/stamps/animal-kawauso-gurasann.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-kirakira',
      label: 'キラキラ',
      svg: 'animal-kawauso-kirakira.svg',
      png: 'animal-kawauso-kirakira.png',
      source: require('../assets/stamps/animal-kawauso-kirakira.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-angry-face',
      label: '怒った',
      svg: 'animal-kawauso-angry-face.svg',
      png: 'animal-kawauso-angry-face.png',
      source: require('../assets/stamps/animal-kawauso-angry-face.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-fire',
      label: '火',
      svg: 'animal-kawauso-fire.svg',
      png: 'animal-kawauso-fire.png',
      source: require('../assets/stamps/animal-kawauso-fire.png')
    },
    {
      category: 'animal',
      code: 'animal-kawauso-isi',
      label: 'いし',
      svg: 'animal-kawauso-isi.svg',
      png: 'animal-kawauso-isi.png',
      source: require('../assets/stamps/animal-kawauso-isi.png')
    },
    { category: 'hanko', code: 'hanko-arigatou', label: 'ありがとう', png: 'hanko-arigatou.png', svg: 'hanko-arigatou.svg', source: require('../assets/stamps/hanko-arigatou.png') },
    { category: 'hanko', code: 'hanko-yokudekimashita', label: 'よくできました', png: 'hanko-yokudekimashita.png', svg: 'hanko-yokudekimashita.svg', source: require('../assets/stamps/hanko-yokudekimashita.png') },
    { category: 'hanko', code: 'hanko-omedetou', label: 'おめでとう', png: 'hanko-omedetou.png', svg: 'hanko-omedetou.svg', source: require('../assets/stamps/hanko-omedetou.png') },
    { category: 'hanko', code: 'hanko-gannbarimashou', label: 'がんばって', png: 'hanko-gannbarimashou.png', svg: 'hanko-gannbarimashou.svg', source: require('../assets/stamps/hanko-gannbarimashou.png') },
    { category: 'hanko', code: 'hanko-atohitoiki', label: 'あとひといき！', png: 'hanko-atohitoiki.png', svg: 'hanko-atohitoiki.svg', source: require('../assets/stamps/hanko-atohitoiki.png') },
    { category: 'hanko', code: 'hanko-hyakytennmannten', label: '百点満点！', png: 'hanko-hyakytennmannten.png', svg: 'hanko-hyakytennmannten.svg', source: require('../assets/stamps/hanko-hyakytennmannten.png') },
    { category: 'hanko', code: 'hanko-mokuhyoutassei', label: '目標達成', png: 'hanko-mokuhyoutassei.png', svg: 'hanko-mokuhyoutassei.svg', source: require('../assets/stamps/hanko-mokuhyoutassei.png') },
    { category: 'hanko', code: 'hanko-ryoukai', label: '了解', png: 'hanko-ryoukai.png', svg: 'hanko-ryoukai.svg', source: require('../assets/stamps/hanko-ryoukai.png') },
    { category: 'hanko', code: 'hanko-syounin', label: '承認', png: 'hanko-syounin.png', svg: 'hanko-syounin.svg', source: require('../assets/stamps/hanko-syounin.png') },
    { category: 'hanko', code: 'hanko-saiyou', label: '採用', png: 'hanko-saiyou.png', svg: 'hanko-saiyou.svg', source: require('../assets/stamps/hanko-saiyou.png') },
    { category: 'hanko', code: 'hanko-saiteishutsu', label: '再提出', png: 'hanko-saiteishutsu.png', svg: 'hanko-saiteishutsu.svg', source: require('../assets/stamps/hanko-saiteishutsu.png') },
    { category: 'gamba', code: 'gamba-kun-arigatou', label: 'ありがとう！', png: 'gamba-kun-arigatou.png', svg: 'gamba-kun-arigatou.svg', source: require('../assets/stamps/gamba-kun-arigatou.png') },
    { category: 'gamba', code: 'gamba-kun-onegai', label: 'お願い！', png: 'gamba-kun-onegai.png', svg: 'gamba-kun-onegai.svg', source: require('../assets/stamps/gamba-kun-onegai.png') },
    { category: 'gamba', code: 'gamba-kun-yattaze', label: 'やったぜ！', png: 'gamba-kun-yattaze.png', svg: 'gamba-kun-yattaze.svg', source: require('../assets/stamps/gamba-kun-yattaze.png') },
    { category: 'gamba', code: 'gamba-kun-oshigotochu', label: 'お仕事中', png: 'gamba-kun-oshigotochu.png', svg: 'gamba-kun-oshigotochu.svg', source: require('../assets/stamps/gamba-kun-oshigotochu.png') },
    { category: 'gamba', code: 'gamba-kun-ureshii', label: '嬉しい！', png: 'gamba-kun-ureshii.png', svg: 'gamba-kun-ureshii.svg', source: require('../assets/stamps/gamba-kun-ureshii.png') },
    { category: 'gamba', code: 'gamba-kun-niyari', label: 'ニヤリ', png: 'gamba-kun-niyari.png', svg: 'gamba-kun-niyari.svg', source: require('../assets/stamps/gamba-kun-niyari.png') },
    { category: 'gamba', code: 'gamba-kun-kiri', label: 'キリッ！', png: 'gamba-kun-kiri.png', svg: 'gamba-kun-kiri.svg', source: require('../assets/stamps/gamba-kun-kiri.png') },
    { category: 'gamba', code: 'gamba-kun-wakuwaku', label: 'ワクワク', png: 'gamba-kun-wakuwaku.png', svg: 'gamba-kun-wakuwaku.svg', source: require('../assets/stamps/gamba-kun-wakuwaku.png') },
    { category: 'gamba', code: 'gamba-kun-daibakusyo', label: '大爆笑www', png: 'gamba-kun-daibakusyo.png', svg: 'gamba-kun-daibakusyo.svg', source: require('../assets/stamps/gamba-kun-daibakusyo.png') },
    { category: 'gamba', code: 'gamba-kun-majika', label: 'まじかー！', png: 'gamba-kun-majika.png', svg: 'gamba-kun-majika.svg', source: require('../assets/stamps/gamba-kun-majika.png') },
    { category: 'gamba', code: 'gamba-kun-gahan', label: 'ガーン orz', png: 'gamba-kun-gahan.png', svg: 'gamba-kun-gahan.svg', source: require('../assets/stamps/gamba-kun-gahan.png') },
    { category: 'gamba', code: 'gamba-kun-namidagaderuhodoureshii', label: '涙が出るほど嬉しい〜', png: 'gamba-kun-namidagaderuhodoureshii.png', svg: 'gamba-kun-namidagaderuhodoureshii.svg', source: require('../assets/stamps/gamba-kun-namidagaderuhodoureshii.png') },
    { category: 'gamba', code: 'gamba-kun-kanashii', label: '悲しい(T . T)', png: 'gamba-kun-kanashii.png', svg: 'gamba-kun-kanashii.svg', source: require('../assets/stamps/gamba-kun-kanashii.png') },
    { category: 'gamba', code: 'gamba-kun-eee', label: 'えーー！！', png: 'gamba-kun-eee.png', svg: 'gamba-kun-eee.svg', source: require('../assets/stamps/gamba-kun-eee.png') },
    { category: 'gamba', code: 'gamba-kun-oregawarukatta', label: '俺が悪かったー', png: 'gamba-kun-oregawarukatta.png', svg: 'gamba-kun-oregawarukatta.svg', source: require('../assets/stamps/gamba-kun-oregawarukatta.png') },
    { category: 'gamba', code: 'gamba-kun-sorehododemo', label: 'てへっ', png: 'gamba-kun-sorehododemo.png', svg: 'gamba-kun-sorehododemo.svg', source: require('../assets/stamps/gamba-kun-sorehododemo.png') },
    { category: 'gamba', code: 'gamba-kun-runrunkibun', label: 'ルンルン気分', png: 'gamba-kun-runrunkibun.png', svg: 'gamba-kun-runrunkibun.svg', source: require('../assets/stamps/gamba-kun-runrunkibun.png') },
    { category: 'gamba', code: 'gamba-kun-mukatsuita', label: 'ムカついた〜', png: 'gamba-kun-mukatsuita.png', svg: 'gamba-kun-mukatsuita.svg', source: require('../assets/stamps/gamba-kun-mukatsuita.png') },
    { category: 'gamba', code: 'gamba-kun-kooritsuku', label: '凍りつく', png: 'gamba-kun-kooritsuku.png', svg: 'gamba-kun-kooritsuku.svg', source: require('../assets/stamps/gamba-kun-kooritsuku.png') },
    { category: 'gamba', code: 'gamba-kun-isogasii', label: '忙しい！', png: 'gamba-kun-isogasii.png', svg: 'gamba-kun-isogasii.svg', source: require('../assets/stamps/gamba-kun-isogasii.png') },
    { category: 'gamba', code: 'gamba-kun-sinisouda', label: '死にそうだー', png: 'gamba-kun-sinisouda.png', svg: 'gamba-kun-sinisouda.svg', source: require('../assets/stamps/gamba-kun-sinisouda.png') },
    { category: 'gamba', code: 'gamba-kun-onakaippai', label: 'お腹いっぱい', png: 'gamba-kun-onakaippai.png', svg: 'gamba-kun-onakaippai.svg', source: require('../assets/stamps/gamba-kun-onakaippai.png') },
    { category: 'gamba', code: 'gamba-kun-tasukete', label: '助けて〜〜', png: 'gamba-kun-tasukete.png', svg: 'gamba-kun-tasukete.svg', source: require('../assets/stamps/gamba-kun-tasukete.png') },
    { category: 'gamba', code: 'gamba-kun-beeruma', label: 'ビールうまー', png: 'gamba-kun-beeruma.png', svg: 'gamba-kun-beeruma.svg', source: require('../assets/stamps/gamba-kun-beeruma.png') },
    { category: 'gamba', code: 'gamba-kun-minnadekanpai', label: 'みんなでカンパーイ！', png: 'gamba-kun-minnadekanpai.png', svg: 'gamba-kun-minnadekanpai.svg', source: require('../assets/stamps/gamba-kun-minnadekanpai.png') },
    { category: 'gamba', code: 'gamba-kun-yoroshikuonegaishimasu', label: 'よろしくお願いします', png: 'gamba-kun-yoroshikuonegaishimasu.png', svg: 'gamba-kun-yoroshikuonegaishimasu.svg', source: require('../assets/stamps/gamba-kun-yoroshikuonegaishimasu.png') },
    { category: 'gamba', code: 'gamba-kun-ittekimasu', label: '行ってきまーす', png: 'gamba-kun-ittekimasu.png', svg: 'gamba-kun-ittekimasu.svg', source: require('../assets/stamps/gamba-kun-ittekimasu.png') },
    { category: 'gamba', code: 'gamba-kun-oukankabutteittousyou', label: '一等賞やったぜ！', png: 'gamba-kun-oukankabutteittousyou.png', svg: 'gamba-kun-oukankabutteittousyou.svg', source: require('../assets/stamps/gamba-kun-oukankabutteittousyou.png') },
    { category: 'gamba', code: 'gamba-kun-kanashiikedosayonara', label: 'さようならー(泣)', png: 'gamba-kun-kanashiikedosayonara.png', svg: 'gamba-kun-kanashiikedosayonara.svg', source: require('../assets/stamps/gamba-kun-kanashiikedosayonara.png') },
    { category: 'gamba', code: 'gamba-kun-ryoukaishimashita', label: '了解しました！', png: 'gamba-kun-ryoukaishimashita.png', svg: 'gamba-kun-ryoukaishimashita.svg', source: require('../assets/stamps/gamba-kun-ryoukaishimashita.png') },
    { category: 'gamba', code: 'gamba-kun-moeagarutoushi', label: '燃え上がる闘志', png: 'gamba-kun-moeagarutoushi.png', svg: 'gamba-kun-moeagarutoushi.svg', source: require('../assets/stamps/gamba-kun-moeagarutoushi.png') },
    { category: 'gamba', code: 'gamba-chan-arigatougozaimasu', label: 'ありがとうございます', png: 'gamba-chan-arigatougozaimasu.png', svg: 'gamba-chan-arigatougozaimasu.svg', source: require('../assets/stamps/gamba-chan-arigatougozaimasu.png') },
    { category: 'gamba', code: 'gamba-chan-yorosikuonegaisimasu', label: 'よろしくお願いします', png: 'gamba-chan-yorosikuonegaisimasu.png', svg: 'gamba-chan-yorosikuonegaisimasu.svg', source: require('../assets/stamps/gamba-chan-yorosikuonegaisimasu.png') },
    { category: 'gamba', code: 'gamba-chan-mechakutyaureshii', label: '嬉しい！', png: 'gamba-chan-mechakutyaureshii.png', svg: 'gamba-chan-mechakutyaureshii.svg', source: require('../assets/stamps/gamba-chan-mechakutyaureshii.png') },
    { category: 'gamba', code: 'gamba-chan-naicyaisou', label: '泣いちゃいそう', png: 'gamba-chan-naicyaisou.png', svg: 'gamba-chan-naicyaisou.svg', source: require('../assets/stamps/gamba-chan-naicyaisou.png') },
    { category: 'gamba', code: 'gamba-chan-yumemigokochi', label: 'ワクワク', png: 'gamba-chan-yumemigokochi.png', svg: 'gamba-chan-yumemigokochi.svg', source: require('../assets/stamps/gamba-chan-yumemigokochi.png') },
    { category: 'gamba', code: 'gamba-chan-tasuketekudasai', label: '助けてください〜', png: 'gamba-chan-tasuketekudasai.png', svg: 'gamba-chan-tasuketekudasai.svg', source: require('../assets/stamps/gamba-chan-tasuketekudasai.png') },
    { category: 'gamba', code: 'gamba-chan-senpaisugoi', label: '先輩すごい！', png: 'gamba-chan-senpaisugoi.png', svg: 'gamba-chan-senpaisugoi.svg', source: require('../assets/stamps/gamba-chan-senpaisugoi.png') },
    { category: 'gamba', code: 'gamba-chan-senpaiganbatte', label: '先輩頑張って！', png: 'gamba-chan-senpaiganbatte.png', svg: 'gamba-chan-senpaiganbatte.svg', source: require('../assets/stamps/gamba-chan-senpaiganbatte.png') },
    { category: 'gamba', code: 'gamba-chan-unun', label: 'うんうん！', png: 'gamba-chan-unun.png', svg: 'gamba-chan-unun.svg', source: require('../assets/stamps/gamba-chan-unun.png') },
    { category: 'gamba', code: 'gamba-chan-isogasii', label: '忙しい！', png: 'gamba-chan-isogasii.png', svg: 'gamba-chan-isogasii.svg', source: require('../assets/stamps/gamba-chan-isogasii.png') },
    { category: 'gamba', code: 'gamba-chan-senpaigomennasai', label: 'ゴメンナサイ！', png: 'gamba-chan-senpaigomennasai.png', svg: 'gamba-chan-senpaigomennasai.svg', source: require('../assets/stamps/gamba-chan-senpaigomennasai.png') },
    { category: 'gamba', code: 'gamba-chan-minnadebanzai', label: 'みんなでバンザーイ', png: 'gamba-chan-minnadebanzai.png', svg: 'gamba-chan-minnadebanzai.svg', source: require('../assets/stamps/gamba-chan-minnadebanzai.png') },
    { category: 'gamba', code: 'gamba-bucho-subarasisugiru', label: '素晴らしすぎる〜', png: 'gamba-bucho-subarasisugiru.png', svg: 'gamba-bucho-subarasisugiru.svg', source: require('../assets/stamps/gamba-bucho-subarasisugiru.png') },
    { category: 'gamba', code: 'gamba-bucho-wakattaryoukai', label: 'わかった！了解', png: 'gamba-bucho-wakattaryoukai.png', svg: 'gamba-bucho-wakattaryoukai.svg', source: require('../assets/stamps/gamba-bucho-wakattaryoukai.png') },
    { category: 'gamba', code: 'gamba-bucho-wahaha', label: 'わははは', png: 'gamba-bucho-wahaha.png', svg: 'gamba-bucho-wahaha.svg', source: require('../assets/stamps/gamba-bucho-wahaha.png') },
    { category: 'gamba', code: 'gamba-bucho-bozen', label: 'ボーゼン', png: 'gamba-bucho-bozen.png', svg: 'gamba-bucho-bozen.svg', source: require('../assets/stamps/gamba-bucho-bozen.png') },
    { category: 'gamba', code: 'gamba-bucho-kiminaradaijyoubu', label: '君なら大丈夫だよ', png: 'gamba-bucho-kiminaradaijyoubu.png', svg: 'gamba-bucho-kiminaradaijyoubu.svg', source: require('../assets/stamps/gamba-bucho-kiminaradaijyoubu.png') },
    { category: 'gamba', code: 'gamba-bucho-ouenshiteru', label: '応援してるぞー！', png: 'gamba-bucho-ouenshiteru.png', svg: 'gamba-bucho-ouenshiteru.svg', source: require('../assets/stamps/gamba-bucho-ouenshiteru.png') },
    { category: 'gamba', code: 'gamba-bucho-totsugekida', label: '突撃だ！', png: 'gamba-bucho-totsugekida.png', svg: 'gamba-bucho-totsugekida.svg', source: require('../assets/stamps/gamba-bucho-totsugekida.png') },
    { category: 'gamba', code: 'gamba-bucho-orenimakasetoke', label: '俺に任せとけ！', png: 'gamba-bucho-orenimakasetoke.png', svg: 'gamba-bucho-orenimakasetoke.svg', source: require('../assets/stamps/gamba-bucho-orenimakasetoke.png') },
    { category: 'gamba', code: 'gamba-bucho-namidagaderuhodoureshii', label: '涙が出るほど嬉しい〜', png: 'gamba-bucho-namidagaderuhodoureshii.png', svg: 'gamba-bucho-namidagaderuhodoureshii.svg', source: require('../assets/stamps/gamba-bucho-namidagaderuhodoureshii.png') },
    { category: 'gamba', code: 'gamba-bucho-yattane', label: 'やったね！', png: 'gamba-bucho-yattane.png', svg: 'gamba-bucho-yattane.svg', source: require('../assets/stamps/gamba-bucho-yattane.png') },
    { category: 'gamba', code: 'gamba-bucho-majika', label: 'まじかー！', png: 'gamba-bucho-majika.png', svg: 'gamba-bucho-majika.svg', source: require('../assets/stamps/gamba-bucho-majika.png') },
    { category: 'gamba', code: 'gamba-bucho-kinmedaruwoganbakunni', label: '金メダルおめでとう', png: 'gamba-bucho-kinmedaruwoganbakunni.png', svg: 'gamba-bucho-kinmedaruwoganbakunni.svg', source: require('../assets/stamps/gamba-bucho-kinmedaruwoganbakunni.png') },
    { category: 'gamba', code: 'gamba-bucho-nihonnichi', label: 'よ！日本一', png: 'gamba-bucho-nihonnichi.png', svg: 'gamba-bucho-nihonnichi.svg', source: require('../assets/stamps/gamba-bucho-nihonnichi.png') },
    { category: 'gamba', code: 'gamba-bucho-zannenjikaikoso', label: '残念！次回こそ', png: 'gamba-bucho-zannenjikaikoso.png', svg: 'gamba-bucho-zannenjikaikoso.svg', source: require('../assets/stamps/gamba-bucho-zannenjikaikoso.png') },
  ]

export default stamps
//module.exports.default = stamps



// WEBPACK FOOTER //
// ./src/config/stamps.js